import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ToggleableValueTypeSelector from "../components/ToggleableValueTypeSelector";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import PanelLayout from "../components/PanelLayout";

class PagerPanel extends Component {
    constructor(props) {
        super(props);
        this.types = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            {
                text: "Context Property",
                xmlType: "contextProperty"
            }
        ];
        this.defaultInputValue = 100;
        this.state = {
            pagerOptions: {
                limitPropertyType: "constantValue",
                limitPropertyValue: this.defaultInputValue,
                isItemCountLimitSelected: false,
                offsetPropertyType: "constantValue",
                offsetPropertyValue: this.defaultInputValue,
                isSkipCountSelected: false
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.updatePagerOptions = this.updatePagerOptions.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.pagerOptions) {
            this.setState({pagerOptions: this.props.clickedNodeInfo.extras.options.pagerOptions}, () => {
                this.updatePagerOptions();
            });
        } else {
            this.updatePagerOptions();
        }
    }


    handleChange(property, value) {
        this.setState(prevState => ({
            pagerOptions: {
                ...prevState.pagerOptions,
                [property]: value
            }
        }), () => {
            this.updatePagerOptions();
        });
    }

    updatePagerOptions() {
        const pagerOptions = this.state.pagerOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let pagerPanelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(pagerPanelInfo.extras, "options")) {
            pagerPanelInfo.extras.options = {};
        }
        pagerPanelInfo.extras.options.pagerOptions = pagerOptions;
        this.props.clickedNodeAction(pagerPanelInfo);
    }

    render() {
        return (
            <PanelLayout>
                <ToggleableValueTypeSelector
                    label="Item Count Limit"
                    nonSelectedLabel="No Limit"
                    selectedType={this.state.pagerOptions["limitPropertyType"]}
                    selectedOption="limitPropertyType"
                    value={this.state.pagerOptions["limitPropertyValue"]}
                    selectedValue="limitPropertyValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.pagerOptions.isItemCountLimitSelected}
                    selectorProperty="isItemCountLimitSelected"
                    defaultInputValue={this.defaultInputValue}
                />
                <ToggleableValueTypeSelector
                    label="Skip Count"
                    nonSelectedLabel="Don't skip"
                    selectedType={this.state.pagerOptions["offsetPropertyType"]}
                    selectedOption="offsetPropertyType"
                    value={this.state.pagerOptions["offsetPropertyValue"]}
                    selectedValue="offsetPropertyValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.pagerOptions.isSkipCountSelected}
                    selectorProperty="isSkipCountSelected"
                    defaultInputValue={this.defaultInputValue}
                />
            </PanelLayout>

        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        node: state.modalInfo.node
    }
}

export default connect(mapStateToProps, {
    hideModal,
    clickedNodeAction,
})(PagerPanel);
